/* eslint-disable import/no-unresolved */

import AnalyzeService from '../../services/analyze';

const analyzeService = new AnalyzeService();

// actions
export const CREATE_SIMPLE_CROSS_CONFIG = 'CREATE_SIMPLE_CROSS_CONFIG';
export const UPDATE_SIMPLE_CROSS_CONFIG = 'UPDATE_SIMPLE_CROSS_CONFIG';

export const LIST_SIMPLE_CROSS_CONFIG = 'LIST_SIMPLE_CROSS_CONFIG';
export const FETCH_CROSS_CONFIG_RESULT = 'FETCH_CROSS_CONFIG_RESULT';
export const DELETE_CROSS_CONFIG_RESULT = 'DELETE_CROSS_CONFIG_RESULT';
export const CHECK_RESULTADO_CRUZAMENTO = 'CHECK_RESULTADO_CRUZAMENTO';

export function checkResultadoCruzamento(customerId, surveyId, resultadoId, newCheckStatus, dispatch) {
  const promise = analyzeService.checkResultadoCruzamento(customerId, surveyId, resultadoId, newCheckStatus);
  dispatch({ type: CHECK_RESULTADO_CRUZAMENTO, payload: promise });
}

/**
 * dispara uma action que realiza o cadastro de uma configuracao de cruzamento
 * simples
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 * @param {*} mainQuestionId id da pergunta principal da configuracao
 * @param {*} configuracao dados da configuracao a ser atualizada { perguntas_cruzadas: number[] }
 */
export function atualizarConfiguracaoCruzamentoSimples(clientId, surveyId, mainQuestionId, configuracao, dispatch) {
  const promise = analyzeService.atualizarConfiguracaoCruzamentoSimples(clientId, surveyId, mainQuestionId, configuracao);
  dispatch({ type: CREATE_SIMPLE_CROSS_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza o cadastro de uma configuracao de cruzamento
 * simples
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 * @param {*} configuracao configuracao a ser criada { perguntas_cruzadas: number[]}
 */
export function criarConfiguracaoCruzamentoSimples(clientId, surveyId, configuracao, dispatch) {
  const promise = analyzeService.criarConfiguracaoCruzamentoSimples(clientId, surveyId, configuracao);
  dispatch({ type: UPDATE_SIMPLE_CROSS_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza a listagem das configuracoes de cruzamento
 * simples
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 */
export function listSimpleCrossConfig(clientId, surveyId, dispatch) {
  const promise = analyzeService.listSimpleCrossConfig(clientId, surveyId);
  dispatch({ type: LIST_SIMPLE_CROSS_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza o fetch de resultados de uma configuracao
 * de cruzamento
 *
 * @param {*} configId id da configuracao do cruzamento
 * @param {*} idPesquisa id da pesquisa que possui o cruzamento
 * @param {*} idPerguntaPrincipal id da pergunta principal do cruzamento
 */
export function fetchCrossConfigResult(customerId, idPesquisa, idPerguntaPrincipal, dispatch) {
  const promise = analyzeService.fetchCrossConfigResult(customerId, idPesquisa, idPerguntaPrincipal);
  dispatch({ type: FETCH_CROSS_CONFIG_RESULT, payload: promise, meta: { idPesquisa, idPerguntaPrincipal }});
}

/**
 * dispara a action que realiza a exclusão da configuração simples
 * 
 * @param {*} configId id da configuracao do cruzamento
 * @param {*} idPesquisa id da pesquisa que possui o cruzamento
 * @param {*} idPerguntaPrincipal id da pergunta principal do cruzamento
 */
export function deleteSimpleCrossConfig(idPesquisa, idCliente, idPerguntaPrincipal, dispatch) {
  const promise = analyzeService.deleteSimpleCrossConfig(idPesquisa, idCliente, idPerguntaPrincipal)
  dispatch({ type: DELETE_CROSS_CONFIG_RESULT, payload: promise });
}
